
import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'mat-animated-icon',
    templateUrl: './mat-animated-icon.component.html',
    styleUrls: ['./mat-animated-icon.component.scss'],
    standalone: false
})
export class MatAnimatedIconComponent implements OnInit {

  @Input() start: String;
  @Input() end: String;
  @Input() colorStart: String = '#144465';
  @Input() colorEnd: String = '#144465';
  @Input() animate: boolean;
  @Input() pointer: boolean = false;
  @Input() size:String;
  @Input() animateFromParent?: boolean = false;
  private Shake:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() shake:boolean = false;
  @Input() doShake:boolean = false;
  @Input() badgeSize:string = 'small';
  @Input() badgeLength:number = 0;
  @Input() badgeHidden:boolean = true;
  @Input() badgeColor:string = 'warn';
  
  

  constructor() { }

  ngOnInit() {
      
    
  }

  toggle() {
    if(!this.animateFromParent) this.animate = !this.animate;
  }
 


}